import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function CtaSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 pb-16 md:px-8 md:pb-24">
        <div className="relative overflow-hidden rounded-lg bg-secondary-900">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20deep%20pine%20green%20texture%20background%20with%20subtle%20paper%20grain%20and%20soft%20diagonal%20light%20streaks%2C%20minimal%20editorial%20style%2C%20calm%20muted%20tones%2C%20wide%20composition%20with%20empty%20space&width=1600&height=600&seq=chigua-cta-band-01&orientation=landscape"
            alt="网报吃瓜 提交线索与纠错入口背景纹理"
            title="提交线索 · 网报吃瓜"
            className="absolute inset-0 h-full w-full object-cover object-top opacity-40"
          />
          <div className="relative flex flex-col items-start gap-6 p-8 md:flex-row md:items-center md:justify-between md:p-12">
            <div className="max-w-xl">
              <h2 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
                发现官方已发声，但这里还没收录？
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-secondary-100">
                把你看到的官方通报、声明或辟谣原文发给我们，附上链接与发布日期。核实后 24 小时内补充时间线，并标注纠错来源。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row md:shrink-0">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-send-plane-line"></i>
                </span>
                提交线索 / 纠错
              </Link>
              <a
                href={`mailto:${siteInfo.email}`}
                rel="nofollow"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-700 px-6 py-3 text-sm font-medium text-background-100 transition-colors hover:border-accent-400 hover:text-accent-200"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                {siteInfo.email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}